import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import "./assets/customFont.css";
import "../src/styles/theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import "antd/dist/antd.css";
import "antd/dist/antd.min.css";
import "./index.css";
import "./App.css";
import "./responsive.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persister, store } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persister}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
